// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3Ivxa","footer":"ModalUpdate_footer__eFJjq"};